import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function NotFound() {
  return (
    <section
      data-testid="not-found-page"
      className="flex min-h-[80vh] flex-col items-center justify-center px-5 pt-20 text-center"
    >
      <SEO title="404 | EVE" description="This page left the stage." />
      <p className="text-stroke font-display text-[26vw] leading-none sm:text-[12rem]">404</p>
      <h1 className="mt-6 font-display text-3xl uppercase tracking-wide sm:text-4xl">
        This page left the <span className="gradient-text">stage</span>.
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-eve-silver">
        The page you&apos;re looking for doesn&apos;t exist — but the rock party is still on.
      </p>
      <Link to="/" data-testid="not-found-back-home-btn" className="btn-primary mt-10">
        <ArrowLeft size={14} /> Back home
      </Link>
    </section>
  );
}
